// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3UGyF","file":"styles_file__21ffZ"};